import React, { useState } from 'react'
import { Form, Formik } from 'formik'
import get from 'lodash.get'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import { useParams } from 'react-router-dom'
import { Button, Space, Tabs, message } from 'antd'
import { formOptions } from '../../../forms/blocks'
import { updateOrder } from '../../../network/Orders'
import { getProductDetailsComplete } from '../../../network/Products'
import FormContent from '../FormContent'
import { getFromKey, getCollectFrom, getFixedDesignCategory } from '../utils/orderHelpers'

const EditOrderEditMeasure = ({ data, productIndex, closeMeasure }) => {
  const { orderId } = useParams()
  const queryClient = useQueryClient()
  const [isCreating, setIsCreating] = useState(false)
  const [activeKey, setActiveKey] = useState('0')

  const isCollection =
    getFromKey(data.orderProducts[productIndex]) === 'collection'

  const productDetails = useQuery(
    [
      'getProductDetailsComplete',
      {
        id: get(
          data,
          `orderProducts.${productIndex}.orderCollection.product`,
          ''
        ),
      },
    ],
    getProductDetailsComplete,
    {
      refetchOnWindowFocus: false,
      enabled: isCollection,
    }
  )

  const editOrder = useMutation((val) => updateOrder(...val), {
    onSuccess: () => {
      message.success('Measures updated !')
      queryClient.invalidateQueries(['getOrderDetails', { id: orderId }])
      closeMeasure()
    },
  })

  const measureForms = get(
    data,
    `orderProducts.${productIndex}.skuMeasurements`,
    []
  )

  const currentProduct = data.orderProducts[productIndex]
  const resolvedMeasureProductType =
    getFromKey(currentProduct) === 'fixed_design'
      ? getFixedDesignCategory(currentProduct)
      : getFromKey(currentProduct)

  const formsInf = isCollection
    ? getCollectFrom(get(productDetails, 'data.category.blocks', []))
    : formOptions[resolvedMeasureProductType]?.measuresForms

  return (
    <>
      <Tabs
        className="orders-tabs"
        activeKey={activeKey}
        defaultActiveKey="0"
        onChange={setActiveKey}
        items={[
          ...measureForms.map((measure, index) => ({
            key: `${index}`,
            label: `Measurement after adjustment ${index + 1}`,
            style: { padding: '0px 24px' },
            children: (
              <Formik
                initialValues={data}
                onSubmit={(values) => editOrder.mutate([values, orderId])}
              >
                {({ values, errors, handleChange }) => (
                  <Form>
                    <FormContent
                      values={values}
                      errors={errors}
                      path={`orderProducts.${productIndex}`}
                      handleChange={handleChange}
                      forms={formsInf?.map((e) => ({
                        ...e,
                        key: e.key.replace('0', `${index}`),
                      })) ?? []}
                    />
                    {!isCreating && (
                      <div style={{ paddingTop: 12, paddingBottom: 24 }}>
                        <Button
                          style={{ marginRight: 12 }}
                          type="primary"
                          htmlType="submit"
                        >
                          Update current measure
                        </Button>
                        <Button
                          onClick={() => {
                            setIsCreating(true)
                            setActiveKey(`${measureForms.length}`)
                          }}
                          type="primary"
                        >
                          Add measure adjustment
                        </Button>
                      </div>
                    )}
                  </Form>
                )}
              </Formik>
            ),
          })),
          ...(isCreating
            ? [
                {
                  key: `${measureForms.length}`,
                  label: `Measurement after adjustment ${measureForms.length + 1}`,
                  style: { padding: '0px 24px' },
                  children: (
                    <Formik
                      initialValues={data}
                      onSubmit={async (values) =>
                        editOrder.mutate([values, orderId])
                      }
                    >
                      {({ values, errors, handleChange }) => (
                        <Form>
                          <FormContent
                            values={values}
                            errors={errors}
                            path={`orderProducts.${productIndex}`}
                            handleChange={handleChange}
                            forms={formsInf?.map((e) => ({
                              ...e,
                              key: e.key.replace(
                                '0',
                                `${measureForms.length}`
                              ),
                            })) ?? []}
                          />
                          <Space style={{ marginTop: 8 }}>
                            <Button
                              loading={editOrder.isLoading}
                              type="primary"
                              htmlType="submit"
                            >
                              Save
                            </Button>
                            <Button
                              disabled={editOrder.isLoading}
                              onClick={() => {
                                setIsCreating(false)
                                if (activeKey === `${measureForms.length}`) {
                                  setActiveKey(`${measureForms.length - 1}`)
                                }
                              }}
                            >
                              Cancel
                            </Button>
                          </Space>
                        </Form>
                      )}
                    </Formik>
                  ),
                },
              ]
            : []),
        ]}
      />
    </>
  )
}

export default EditOrderEditMeasure
